import type { Advisory } from "@ca.vmedia.tv/swagger-api";

export enum ParentControlOptionType {
    Rating = "rating",
    Times = "times"
};

export interface IRating {
    title: string | null;
    id: Advisory | null;
};

export interface ITime {
    title?: string | null;
    type: number | null;
    time: number;
};

export interface LSTime {
    type: number | null;
    time: number;
};
